<template>
  <div class="company-container" data-content="salary">

    <nav class="company-nav">
      <span @click="changeContent" data-content="salary">初任給額</span>
      <span @click="changeContent" data-content="data">会社データ</span>
    </nav>

    <div id="data" class="l-main company-main">
      <section class="company-basic">
        <div class="ttl-com is-company">
          <div class="ttl-com__wrap01">
            <p class="ttl-com__cate is-blue">{{ company.industry_name }}</p>
            <p class="ttl-com__cate is-green">{{ company.prefecture_name }}</p>
            <p v-if="company.employee_category" class="ttl-com__cate">{{ company.employee_category }}</p>
          </div>
          <h1 class="ttl-com__ttl">{{ company.company_name }}</h1>
          <div class="ttl-com__wrap02">

            <div class="sns">
              <a v-if="isEnableVideo" href="#video" class="btn-short">ショート動画</a>
              <Like :company="company"></Like>
              <Share :company="company"></Share>
            </div>
          </div>
          <p class="ttl-com__income">
            平均年収（平均{{ (company.average_age == null) ? '---' : company.average_age }}歳）
            <span v-html="average_annual_salary"></span>
          </p>
        </div>
      </section>

      <section class="company">
        <div class="company-data">
          <h2 class="company__ttl-bg">会社データ</h2>
          <div class="company__data">
            <table class="company__table">
              <tbody>
              <tr class="company__tr">
                <th class="company__th">業種</th>
                <td class="company__td">{{ company.sub_industry_name }}</td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">本社</th>
                <td class="company__td">{{ company.address }}</td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">設立</th>
                <td class="company__td">{{ company.established_year }}年</td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">資本金</th>
                <td class="company__td">{{ capital_amount }}</td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">売上高</th>
                <td class="company__td">{{ sales }}（{{ company.sales_fiscal_year }}）</td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">従業員数</th>
                <td class="company__td">
                  {{ (company.employees == null) ? '---' : company.employees.toLocaleString() + '名' }}
                </td>
              </tr>
              <tr class="company__tr">
                <th class="company__th">事業所</th>
                <td class="company__td">{{ company.business_offices }}</td>
              </tr>
              </tbody>
            </table>

            <a target="_blank" v-if="company.recruitment_url" @click="trackClick" class="cmpany-link"
               :href="company.recruitment_url">企業採用webサイトへ</a>

          </div>
        </div>
      </section>

      <section v-if="isEnableVideo" class="short-vertical" id="video">
        <h2 class="ttl-short is-small is-company">企業ショート動画</h2>
        <div>
          <div v-for="video in company.company_video" class="short-vertical__item" :id="'video'+video.id">
            <div class="short-vertical__video">
              <iframe
                  :id="'company_video'+video.id"
                  :data-id="video.id"
                  class="youtube-video"
                  width="380"
                  height="676"
                  :src="'https://www.youtube.com/embed/'+video.youtube_id+'?si=7YQze05oBIeKaBus&enablejsapi=1'"
                  title="YouTube video player"
              ></iframe>
            </div>
            <p class="short-vertical__caption">{{ video.title }}</p>
            <p class="short-vertical__date">更新日：{{ video.update_date }}</p>
          </div>
        </div>
      </section>
    </div>

    <div class="l-sub company-salary">
      <section class="salary">

        <div v-if="!hasSalary">
          <div class="salary__simulation">
            <p class="salary__ttl-bd">初任給額</p>
            <p class="salary__empty">
              初任給の情報はありません
            </p>
          </div>
          <table class="salary__table02">
            <tbody>
            <tr class="salary__tr02">
              <th class="salary__th02">諸手当</th>
              <td class="salary__td02">ー</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">賞与</th>
              <td class="salary__td02">ー</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">休日休暇</th>
              <td class="salary__td02">ー</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">勤務時間</th>
              <td class="salary__td02">ー</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">その他</th>
              <td class="salary__td02">ー</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="hasSalary">
          <div v-for="salary in company.company_salary" class="salary__simulation">
            <p class="salary__ttl-bd">初任給額：{{ salary.job_type }}</p>
            <div v-for="child in salary.children" class="salary__wrap-sim">
              <p class="salary__salary">
                <span class="salary__salary-label">{{ child.education_level_name }}</span>
                <strong>{{ child.salary.toLocaleString() }}</strong>
                <span class="salary__salary-unit">円</span>
                <span class="salary__salary-small">（月給）</span>
              </p>
              <a :href="`/companies/${company.company_id}/simulation?job_type=${encodeURIComponent(salary.job_type)}&education_level_id=${child.education_level_id}`"
                 class="salary__btn-sim">シミュレーション</a>
            </div>
          </div>
          <table class="salary__table02">
            <tbody>
            <tr class="salary__tr02">
              <th class="salary__th02">諸手当</th>
              <td class="salary__td02">{{ company.allowances }}</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">賞与</th>
              <td class="salary__td02">{{ company.bonus }}</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">休日休暇</th>
              <td class="salary__td02">{{ company.holiday_vacation }}</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">勤務時間</th>
              <td class="salary__td02">{{ company.working_hours }}</td>
            </tr>
            <tr class="salary__tr02">
              <th class="salary__th02">その他</th>
              <td class="salary__td02">{{ company.other }}</td>
            </tr>
            </tbody>
        </table>
        </div>
      </section>
    </div>


    <br style="clear: both">

  </div>
</template>
<script setup lang="ts">
import {computed, onMounted} from "vue";
import {Storage} from "../../localstorage/Storage";
import {usePageStore} from "../../stores/page";
import Like from "../parts/Like.vue";
import Share from "../parts/Share.vue";
import {NaviClient} from "../../api/NaviClient";

const pageDataStore = usePageStore();
const company = pageDataStore.pageData;

onMounted(() => {
  if (!globalThis.IS_USER_LOGIN) {
    Storage.addHistory(company);
  }
  if(!hasSaalryData()){
    const container: any = document.querySelector('.company-container');
    container.dataset.content = 'data';
  }
  setInterval(_setContentHeight, 1000);

});

const employees = computed(() => {

});

const hasSalary = computed(()=>{
  return hasSaalryData();
});

const hasSaalryData = () => {
  if(company.company_salary==null){
    return false;
  }
  if(company.company_salary.length==0){
    return false;
  }
  return true;
}

const changeContent = e => {
  const content = e.currentTarget.dataset.content;
  const container: any = document.querySelector('.company-container');
  container.dataset.content = content;
  _setContentHeight();
}

const _setContentHeight = () => {
  const container: any = document.querySelector('.company-container');
  const content = container.dataset.content;
  //スマホのみ対応
  const nav = document.querySelector('.company-nav');
  const company: any = document.querySelector('.company');
  if (nav.checkVisibility()) {
    //高さを揃える : videoコンテンツの表示のため
    if (content == 'data') {//データの場合は
      company.style.height = 'auto';
    } else {
      const basic: any = document.querySelector('.company-basic');
      const salary: any = document.querySelector('.company-salary');
      company.style.height = (salary.offsetHeight + basic.offsetHeight) + 'px';
    }
  } else {
    company.style.height = 'auto';
    return;
  }
}

const isEnableVideo = computed(() => {
  return company.company_video_status && company.company_video.length;
})

const average_annual_salary = computed(() => {
  if (company.average_annual_salary == null) {
    return '<span class="ttl-com__income-s">---&nbsp;万円</span>';
  }
  // 万円単位で小数第一位を四捨五入してから表示する（円値に戻して formatPrice に渡す）
  const roundedManYen = Math.round(company.average_annual_salary / 10000) * 10000;
  const formatPrice = navi.formatPrice(roundedManYen);
  let value = '';
  for (let i = 0; i < formatPrice.length; i++) {
    value += `<strong>${formatPrice[i].value}</strong>`;
    value += `<span class="ttl-com__income-s">${formatPrice[i].label}</span>`;
  }
  return value;
})

const capital_amount = computed(() => {
  if (company.capital_amount == null) {
    return '---';
  }
  const formatPrice = navi.formatPrice(company.capital_amount);
  let value = '';
  for (let i = 0; i < formatPrice.length; i++) {
    value += formatPrice[i].value + formatPrice[i].label;
  }
  return value;
})

const sales = computed(() => {
  if (company.sales == null) {
    return '---';
  }
  const formatPrice = navi.formatSalesPrice(company.sales);
  let value = '';
  for (let i = 0; i < formatPrice.length; i++) {
    value += formatPrice[i].value + formatPrice[i].label;
  }
  return value;
})

const trackClick = (e) => {
  const click_url = e.currentTarget.href;
  NaviClient.recruitLink(company.company_id, click_url).then((json) => {
    console.log(json);
  }).catch((error) => {
    console.log(error);
  })
}


// Youtube API 再生のトラッキング ----------------------------------------------
const EVENT_PLAY = 1;
globalThis.onYouTubePlayerAPIReady = function (e) {
  document.querySelectorAll('.youtube-video').forEach((el: any) => {
    var iframe = el;
    new YT.Player(el.id, {
      events: {
        'onStateChange': (e) => {
          if (e.data == EVENT_PLAY) {
            NaviClient.playVideo(el.dataset.id).then((json) => {
              console.log(json);
            }).catch((error) => {
              console.log(error);
            });
          }
        }
      }
    });
  });
};
let script = document.createElement("script");
script.setAttribute('src', 'https://www.youtube.com/iframe_api');
document.head.appendChild(script);

const simulationUrl = (job_type_id, education_level_id) => {
  return `/companies/${company.company_id}/simulation?job_type=${job_type_id}&education_level_id=${education_level_id}`;
};


</script>